import React from "react"
import Form from "semantic-ui-react/dist/es/collections/Form/Form"

const WorksheetFieldGroup = ({ children }) => {
  const fieldWidth = Math.ceil(16 / React.Children.count(children))
  const childrenWithWidth = React.Children.map(children, child =>
    React.cloneElement(child, { fieldWidth })
  )
  return (
    <Form.Group style={{ flexWrap: "nowrap" }}>{childrenWithWidth}</Form.Group>
  )
}

WorksheetFieldGroup.displayName = "WorksheetFieldGroup"

WorksheetFieldGroup.propTypes = {
  children: (props, propName, component) => {
    const prop = props[propName]
    let error
    React.Children.forEach(prop, child => {
      if (child.type.displayName !== "WorksheetField") {
        error = new Error(
          `${component} requires WorksheetField as its immediate children`
        )
      }
    })
    return error
  }
}
export default WorksheetFieldGroup
